const Logo = () => {
  return <img src="/assets/logo.png" alt="logo" height={35} />;
};

export default Logo;
